import { render, staticRenderFns } from "./VideoPreview.vue?vue&type=template&id=5487bb55&scoped=true&"
import script from "./VideoPreview.vue?vue&type=script&lang=ts&"
export * from "./VideoPreview.vue?vue&type=script&lang=ts&"
import style0 from "./VideoPreview.vue?vue&type=style&index=0&id=5487bb55&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5487bb55",
  null
  
)

export default component.exports